const ABSOLUTE_PROTOCOL_REGEX = /^(https?:|mailto:|tel:)/i

export const resolveHref = (value?: string | null, fallback = '/'): string => {
  if (!value) return fallback
  if (value === '#') return '#'
  if (ABSOLUTE_PROTOCOL_REGEX.test(value)) {
    return value
  }
  const normalized = value.replace(/^\/+/, '')
  return `/${normalized}`
}

